/* eslint-disable no-param-reassign */
const partnerFilters = document.querySelectorAll('.partnerFilter__term');
const partners = document.querySelectorAll('.partnerCard');

function filterPartners(event) {
  // Get clicked pill
  const filterTarget = event.target;
  // Get filter data
  const data = filterTarget.dataset.slug;

  // reset filter if requested
  if (data === 'reset') {
    // Display all partners
    partners.forEach((partner: HTMLElement) => {
      partner.style.display = '';
    });
    // Set all filters to not active
    partnerFilters.forEach((filter: HTMLElement) => {
      filter.dataset.active = 'false';
    });
    // Set all filters button to active
    filterTarget.dataset.active = 'true';
    return;
  }

  // Set all filters to non-active
  partnerFilters.forEach((filter: HTMLElement) => {
    filter.dataset.active = 'false';
  });
  // Set targeted filter to active
  filterTarget.dataset.active = 'true';

  // Filter the partners
  partners.forEach((partner: HTMLElement) => {
    if (partner.dataset.terms) {
      const termArray = JSON.parse(partner.dataset.terms);
      if (termArray.includes(data)) {
        partner.style.display = '';
      } else {
        partner.style.display = 'none';
      }
    }
  });
}

partnerFilters.forEach((filter) => {
  filter.addEventListener('click', filterPartners);
});
